import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOnline: typeof window !== 'undefined' && window.navigator ? window.navigator.onLine : true,
  isApiReachable: true,
};

const networkStatusSlice = createSlice({
  name: "networkStatus",
  initialState,
  reducers: {
    setOnline(state) { state.isOnline = true; },
    setOffline(state) { state.isOnline = false; },
    setApiReachable(state) { state.isApiReachable = true; },
    setApiUnreachable(state) { state.isApiReachable = false; },
  },
});

export const { setOnline, setOffline, setApiReachable, setApiUnreachable } = networkStatusSlice.actions;
export default networkStatusSlice.reducer;